import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom-v5-compat';

// @ts-expect-error - PageLayout does not have TypeScript definitions
import PageLayout from 'src/components/PageLayout';
import { materializeCopilotImport } from 'src/graphql/copilotImport/materializeCopilotImport';
import { useHistory } from 'src/lib/hooks';
import { formatProjectRoute } from 'src/lib/routing';
import { ROUTES } from 'src/routes';
// @ts-expect-error - useNotificationActions is JS-only
import { useNotificationActions } from 'src/store/notification';

export const CopilotImportPage = () => {
  const history = useHistory();
  const notificationActions = useNotificationActions();
  const { jobId } = useParams<{ jobId: string }>();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!jobId) {
      history.replace(ROUTES.ROOT);
      return;
    }

    let cancelled = false;

    materializeCopilotImport(jobId)
      .then((payload) => {
        if (cancelled) return;
        history.replace(formatProjectRoute(payload.project.id));
      })
      .catch((error: Error) => {
        if (cancelled) return;
        const message = error?.message || 'Could not open this Copilot import.';
        setErrorMessage(message);
        notificationActions.displayError(new Error(message));
      });

    return () => {
      cancelled = true;
    };
  }, [jobId, history, notificationActions]);

  return (
    <PageLayout>
      <div style={{ padding: 48, textAlign: 'center' }}>
        {errorMessage ? (
          <>
            <h2>Couldn’t open this Copilot result</h2>
            <p>{errorMessage}</p>
          </>
        ) : (
          <p>Opening your Copilot result in Anyword…</p>
        )}
      </div>
    </PageLayout>
  );
};
